/* NUOMA 3.7 — Fiche produit : quantité, repères par finition, dates de livraison. */
(() => {
  const clean = text => (text || '').replace(/\s+/g, ' ').trim();

  /* ---------- Quantité (− 1 +) ----------
     Le nombre est affiché dans un simple texte (pas un champ natif), ce qui garantit
     un rendu identique sur iPhone, Android et ordinateur. La valeur envoyée au panier
     est dans un champ caché. */
  function syncStepper(stepper) {
    const input = stepper.querySelector('[data-quantity-input]');
    if (!input) return;
    const max = Math.max(1, parseInt(input.dataset.max, 10) || 10);
    let value = parseInt(input.value, 10);
    if (!Number.isFinite(value) || value < 1) value = 1;
    if (value > max) value = max;
    input.value = String(value);
    const output = stepper.querySelector('[data-quantity-value]');
    if (output) output.textContent = String(value);
    const minus = stepper.querySelector('[data-step="-1"]');
    const plus = stepper.querySelector('[data-step="1"]');
    if (minus) minus.disabled = value <= 1;
    if (plus) plus.disabled = value >= max;
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-nuoma-stepper] [data-step]');
    if (!button) return;
    event.preventDefault();
    const stepper = button.closest('[data-nuoma-stepper]');
    const input = stepper.querySelector('[data-quantity-input]');
    input.value = String((parseInt(input.value, 10) || 1) + Number(button.dataset.step));
    syncStepper(stepper);
  });

  /* ---------- Repères qui suivent la finition choisie ---------- */
  function readSpecs(container) {
    const specs = {};
    container.querySelectorAll('li').forEach(li => {
      const label = li.querySelector('strong');
      if (!label) return;
      const key = clean(label.textContent).replace(/\s*:\s*$/, '').toLowerCase();
      const value = clean(li.textContent.replace(label.textContent, ''));
      if (key && value) specs[key] = value;
    });
    return specs;
  }
  function mountLabel(raw, hasManual) {
    const text = (raw || '').toLowerCase();
    if (!text) return '';
    if (text.includes('livré monté') || text.includes('livre monte')) return 'Livré monté';
    return hasManual ? 'À monter, notice fournie' : 'À monter';
  }
  function updateVariant(section, sku) {
    const blocks = [...section.querySelectorAll('.nuoma-variant-details[data-nuoma-sku]')];
    const match = sku ? blocks.find(b => b.dataset.nuomaSku.trim() === sku.trim()) : null;
    if (blocks.length > 1 && match) blocks.forEach(b => b.classList.toggle('is-other-variant', b !== match));
    const facts = section.querySelector('[data-nuoma-facts]');
    if (!facts || !match) return;
    const specs = readSpecs(match);
    const dims = specs['dimensions'] ? specs['dimensions'].split('(')[0].trim() : '';
    const dimItem = facts.querySelector('[data-fact="dimensions"]');
    if (dimItem && dims) { dimItem.querySelector('[data-fact-value]').textContent = dims; dimItem.hidden = false; }
    const mountItem = facts.querySelector('[data-fact="mount"]');
    if (mountItem && specs['montage']) {
      const hasManual = !!section.querySelector('.nuoma-manual__link');
      const label = mountLabel(specs['montage'], hasManual);
      if (label) { mountItem.querySelector('[data-fact-value]').textContent = label; mountItem.hidden = false; }
    }
  }
  function onVariant(select) {
    const section = select.closest('[data-product-section]');
    const option = select.selectedOptions[0];
    if (!section || !option) return;
    updateVariant(section, option.dataset.sku || '');
    const stepper = section.querySelector('[data-nuoma-stepper]');
    if (stepper) {
      const input = stepper.querySelector('[data-quantity-input]');
      input.dataset.max = String(Math.max(1, Math.min(10, parseInt(option.dataset.maxQty, 10) || 10)));
      syncStepper(stepper);
    }
  }
  document.addEventListener('change', event => {
    if (event.target.matches?.('[data-variant-select]')) onVariant(event.target);
  });

  /* ---------- Dates de livraison estimées (jours ouvrés, lundi-vendredi) ---------- */
  function addBusinessDays(start, days) {
    const date = new Date(start);
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return date;
  }
  function initEta(el) {
    const min = parseInt(el.dataset.min, 10);
    const max = parseInt(el.dataset.max, 10);
    if (!min || !max) return;
    const now = new Date();
    const from = addBusinessDays(now, min);
    const to = addBusinessDays(now, max);
    const lang = document.documentElement.lang || 'fr';
    let text;
    try {
      const day = new Intl.DateTimeFormat(lang, {day: 'numeric'});
      const full = new Intl.DateTimeFormat(lang, {day: 'numeric', month: 'long'});
      const fromText = from.getMonth() === to.getMonth() ? day.format(from) : full.format(from);
      text = `Commandé aujourd’hui, reçu entre le ${fromText} et le ${full.format(to)}.`;
    } catch (_) { return; }
    el.textContent = text;
    el.hidden = false;
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-nuoma-stepper]').forEach(syncStepper);
    scope.querySelectorAll('[data-nuoma-eta]').forEach(initEta);
    scope.querySelectorAll('[data-variant-select]').forEach(onVariant);
    // Produit sans sélecteur : n'afficher que la fiche technique de la variante unique si besoin.
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.querySelector('[data-variant-select]')) return;
      const sku = clean(section.querySelector('[data-product-sku]')?.textContent || '').replace(/^Réf\.\s*/, '');
      if (sku) updateVariant(section, sku);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
